'use client';

import usePrimeStore from '@/lib/state-stores/primeStore';
import useUserStore from '@/lib/state-stores/userStore';
import useWishListStore from '@/lib/state-stores/whishlistStore';
import { Prime } from '@/types/prime';
import { ProfileRequest } from '@/types/Profile';
import { TAllWishlist } from '@/types/wishlist';
import { useEffect } from 'react';

type Props = {
  wishlists: TAllWishlist[];
  prime: Prime;
  user?: ProfileRequest | null;
};
const GlobalStore = ({ wishlists, prime, user }: Props) => {
  const { setWishlist } = useWishListStore();
  const { setPrime } = usePrimeStore();
  const { setUser } = useUserStore();

  useEffect(() => {
    if (user) {
      setUser(user);
    }
  }, [user, setUser]);

  useEffect(() => {
    if (wishlists) {
      setWishlist(wishlists);
    }
  }, [wishlists, setWishlist]);

  useEffect(() => {
    if (prime) {
      setPrime(prime);
    }
  }, [prime, setPrime]);

  return null;
};

export default GlobalStore;
